import axios from "axios";

const instance = axios.create({
  baseURL: "https://api.flaplive.com",
});

export default instance;